import { render } from "./redirect.vue?vue&type=template&id=47657a4c&scoped=true"
import script from "./redirect.vue?vue&type=script&lang=js"
export * from "./redirect.vue?vue&type=script&lang=js"

import "./redirect.vue?vue&type=style&index=0&id=47657a4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47657a4c"]])

export default __exports__